<svg viewBox="0 0 960 540" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
    class="min-h-screen min-w-screen fixed left-0" style="bottom:-10rem" preserveAspectRatio="none">
    <rect x="0" y="0" width="960" height="540" fill="var(--surface-ground)"></rect>
    <path
        d="M0 331L26.7 321C53.3 311 106.7 291 160 291C213.3 291 266.7 311 320 329.5C373.3 348 426.7 365 480 373.2C533.3 381.3 586.7 380.7 640 373.8C693.3 367 746.7 354 800 341.2C853.3 328.3 906.7 315.7 933.3 309.3L960 303L960 541L933.3 541C906.7 541 853.3 541 800 541C746.7 541 693.3 541 640 541C586.7 541 533.3 541 480 541C426.7 541 373.3 541 320 541C266.7 541 213.3 541 160 541C106.7 541 53.3 541 26.7 541L0 541Z"
        fill="var(--purple-500)" stroke-linecap="round" stroke-linejoin="miter"></path>
</svg>
<!-- wrapper -->
<div class="grid justify-content-center px-3 md:px-5 py-4 bg-gray-100 min-h-screen">
    <div class="col-12 md:col-10 lg:col-8 xl:col-6">

        <!-- CARD PERFIL/LOJA -->
        <div class="profile-card surface-card border-round-2xl shadow-none mb-4">
            <!-- capa -->
            <div class="cover"></div>

            <!-- conteúdo -->
            <div class="p-4 relative">
                <!-- avatar sobre a capa -->
                <div class="avatar">
                    <img src="assets/maiorSSSS.png" alt="Logo" />
                    <span class="status-dot"></span>
                </div>

                <!-- ícone de ações (menu) -->
                <button pButton type="button" class="p-button-text p-button-rounded action-btn"
                    icon="pi pi-ellipsis-v"></button>

                <!-- título + subtítulo -->
                <div class="mt-3">
                    <h2 class="m-0 text-900 text-xl md:text-2xl font-semibold">Slicksell Video Commerce Ltda</h2>
                    <p class="m-0 text-600 text-sm">Video-first experience</p>
                </div>

                <!-- chips/atalhos -->
                <div class="flex gap-2 mt-3">
                    <p-tag value="Loja" severity="secondary"></p-tag>
                    <p-tag value="Player" severity="contrast" icon="pi pi-play"></p-tag>
                </div>
            </div>
        </div>

        <!-- BLOCO: Conectar conta -->
        <div class="card border-round-2xl shadow-none relative">
            <h3 class="section-title">Conectar conta</h3>
            <div class="grid">
                <div class="col-12 md:col-4">
                    <button class="connect-tile w-full" pRipple (click)="connect('instagram')">
                        <img src="assets/logo_instagram_recortado.png" alt="Instagram" />
                        <span>Instagram</span>
                    </button>
                </div>
                <div class="col-12 md:col-4">
                    <button class="connect-tile w-full" pRipple (click)="connect('tiktok')">
                        <img src="assets/tiktok.webp" alt="TikTok" />
                        <span>TikTok</span>
                    </button>
                </div>
                <div class="col-12 md:col-4">
                    <button class="connect-tile w-full" pRipple (click)="connect('youtube')">
                        <img src="assets/youtube-color.svg" alt="YouTube" />
                        <span>Youtube</span>
                    </button>
                </div>
            </div>
        </div>

        <!-- BLOCO: Gerenciar contas -->
        <!-- BLOCO: Gerenciar contas -->
        <!-- <div class="card border-round-2xl shadow-none relative">
            <h3 class="section-title">Gerenciar contas</h3>
            <div class="grid">
                <div class="col-12 md:col-4">
                    <button class="manage-tile w-full" pRipple (click)="manage('instagram')">
                        <span class="corner-badge brand-facebook">f</span>
                        <div class="icon">
                            <img src="assets/logo_instagram_recortado.png" alt="Instagram" />
                        </div>
                        <span class="label">Instagram</span>
                    </button>
                </div>

                <div class="col-12 md:col-4">
                    <button class="manage-tile w-full" pRipple (click)="manage('tiktok')">
                        <span class="corner-badge brand-tiktok">t</span>
                        <div class="icon">
                            <img src="assets/tiktok.webp" alt="TikTok" />
                        </div>
                        <span class="label">TikTok</span>
                    </button>
                </div>

                <div class="col-12 md:col-4">
                    <button class="manage-tile w-full" pRipple (click)="manage('youtube')">
                        <span class="corner-badge brand-google">G+</span>
                        <div class="icon">
                            <img src="assets/youtube-color.svg" alt="YouTube" />
                        </div>
                        <span class="label">Youtube</span>
                    </button>
                </div>
            </div>
        </div> -->

    </div>
</div>